import React from 'react';
import Edit from '../../../icons/Edit';
import styles from './CartItem.module.scss';
import DetailedView from './DetailedView';
import { Link } from 'react-router-dom';
import routes from '../../../../routes';
import { addonSheetToSheet } from '../../../PackageBuilders/MultiPose/functions';
import cn from 'classnames';
import Extras from './Extras';
import Footer from './Footer';

const MultiPoseItem = ({
                         orderPackage,
                         removeItem,
                         editable,
                       }) => {
  const sheetsByTypeName = orderPackage.sheets.reduce((acc, cur) => {
    const key = cur.imageTypeValue.trim();

    if (acc[key]) acc[key].push(cur);
    else acc[key] = [cur];

    return acc;
  }, {});

  const addonSheetsByName = orderPackage.addonSheets.reduce((acc, cur) => {
    const key = cur.addon.name.trim();

    if (acc[key]) acc[key].push(addonSheetToSheet(cur));
    else acc[key] = [addonSheetToSheet(cur)];

    return acc;
  }, {});

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerWrapper}>
        <div className={styles.bigTitle}>{orderPackage.package.name}</div>
      </div>
      <div className={styles.optionTitle}>{orderPackage.apiOption.name}</div>
      {editable && (
        <div className={styles.actions}>
          <Link to={routes.multiPoseEdit(orderPackage.id)}>
            <Edit onClick={() => {}} />
          </Link>
        </div>
      )}
      <div className={cn({ [styles.sheetList]: orderPackage.addonSheets.length > 0 })}>
        <DetailedView orderPackageId={orderPackage.id} sheetsByTypeName={sheetsByTypeName} />
      </div>
      {orderPackage.addonSheets.length > 0 && (
        <div>
          <p className={cn(styles.addonHeader, styles.withPl)}>Additional addons:</p>
          <DetailedView type="Addons" orderPackageId={orderPackage.id} sheetsByTypeName={addonSheetsByName} />
        </div>
      )}
      <Extras orderPackage={orderPackage} removeItem={removeItem} editable={editable} />
      <Footer orderPackage={orderPackage} removeItem={removeItem} editable={editable} />
    </div>
  );
};

export default MultiPoseItem;
